<template>
  <div v-if="deadReasons.length">
    <div
      v-for="(deadReason, index) in deadReasons"
      :key="index"
      class="my-7 break-normal whitespace-nowrap"
    >
      {{ deadReason }}
    </div>
  </div>
  <div v-else>-</div>
</template>
<script lang="ts" setup>
import { type PropType, computed } from "vue";
import { useStore } from "vuex";

const props = defineProps({
  value: {
    type: Array as PropType<number[]>,
  },
});

const { getters } = useStore();

const declineReasons = computed(
  () => getters["options/placementDeclineReasons"]
);

const deadReasons = computed(() => {
  return (
    props.value?.map(
      (deadReasonId) => declineReasons.value[deadReasonId] || "-"
    ) ?? []
  );
});
</script>
